export default __webpack_public_path__ + "static/media/oola_w.628a599b.svg";